const img = require('./Left Hand Outswing.svg'); export default img;